import {axios as http} from "@/plugins/http"

export default class Api {
    static items(query) {
        let config = {
            params: query,
        }

        return http.get("/api/v1/post/site/tags/items", config);
    }
}
